import styles from './MethodSwitcher.module.css';

export interface MethodSwitcherOption<T extends string> {
	value: T;
	label: string;
}

interface MethodSwitcherProps<T extends string> {
	value: T;
	options: MethodSwitcherOption<T>[];
	onChange: (value: T) => void;
	label: string;
}

/* A single thin row of choices for the door: one tap switches how tickets are read. */
export const MethodSwitcher = <T extends string>({ value, options, onChange, label }: MethodSwitcherProps<T>) => (
	<div className={styles.bar} role="radiogroup" aria-label={label}>
		{options.map((option) => (
			<button
				key={option.value}
				type="button"
				role="radio"
				aria-checked={option.value === value}
				className={option.value === value ? styles.optionActive : styles.option}
				onClick={() => onChange(option.value)}
			>
				{option.label}
			</button>
		))}
	</div>
);
